// src/hooks/useCrudData.js
import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const useFaqData = () => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/FaqsCollection");
        setData(response.data?.rows || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    if (!axiosLoading) {
      fetchData();
    }
  }, [axiosLoading]);

  const postData = async (newData) => {
    try {
      const { title, content, faq_order } = newData; // Destructure newData object
      const postData = {
        jsStruct: JSON.stringify({
          title,
          content,
          faq_order,
        }),
      };
      const response = await axios.post("/FaqsCollection", postData);
      return response.data;
    } catch (error) {
      console.error("Error adding data:", error);
      throw error;
    }
  };

  const updateData = async (updatedData) => {
    try {
      const { id, title, content, faq_order } = updatedData;
      const putData = {
        jsStruct: JSON.stringify({
          id,
          title,
          content,
          faq_order,
        }),
      };
      const response = await axios.put(`/FaqsMember/${id}`, putData);
      setData((prevData) =>
        prevData.map((item) =>
          item.id === id ? { ...item, ...updatedData } : item
        )
      );
      return response.data;
    } catch (error) {
      console.error("Error updating data:", error);
      throw error;
    }
  };

  const deleteData = async (faqId) => {
    try {
      await axios.delete(`/FaqsMember/${faqId}`);
      setData(data.filter((faq) => faq.id !== faqId));
    } catch (error) {
      console.error("Error deleting faq:", error);
      throw error;
    }
  };

  const updateFaqOrder = async (reorderedFaqs) => {
    try {
      // Update the local state immediately for better UX
      setData(reorderedFaqs);

      // Send bulk update to backend
      const updatePromises = reorderedFaqs.map((faq, index) => {
        const updatedFaq = { ...faq, faq_order: index + 1 };
        const putData = {
          jsStruct: JSON.stringify({
            id: faq.id,
            title: faq.title,
            content: faq.content,
            faq_order: index + 1,
          }),
        };
        return axios.put(`/FaqsMember/${faq.id}`, putData);
      });

      await Promise.all(updatePromises);
    } catch (error) {
      console.error("Error updating FAQ order:", error);
      throw error;
    }
  };

  return {
    data,
    loading,
    error,
    postData,
    updateData,
    deleteData,
    updateFaqOrder,
  };
};

export default useFaqData;
